import CarIcon from 'components/elements/icons/CarIcon'
import RequesterIcon from 'components/elements/icons/RequesterIcon'
import MapTemplate from 'components/templates/MapTemplate'
import { CLIENT_SETTINGS } from 'constants/clientSettings'
import { PAGE_PATH } from 'constants/pagePath'
import { HistoryStackContext } from 'contexts/HistoryStackContext'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { QnStatesProps } from 'states/QnState'
import { StatesProps } from 'utils/commonHooks'
import { updateLog } from 'utils/log'
import { StatusProps } from 'utils/status'
import { useEditQnState } from '../../../utils/commonHooks'

const TITLE = '車の場所選択画面'

/** 車の場所選択画面のボタンラベル */
const TROUBLE_PLACE_BUTTON_LABEL = 'トラブル場所に設定する'

/**
 * QN-04:車の場所選択画面
 */
const TroublePlace: React.FC<StatesProps> = (props: QnStatesProps) => {
  const { state, setState } = props
  const historyStackContext = useContext(HistoryStackContext)
  const [location, setLocation] = useState(state.location)
  const [isDisabled, setIsDisabled] = useState(false)
  const [editingItem, ,] = useEditQnState()

  const forwardAction = useCallback((): StatusProps => {
    updateLog(TITLE, { location }, historyStackContext)
    const updateState = {
      ...state,
      location: { ...location, isSelected: true },
    }
    if (!state.destinationLocation.isSelected) {
      updateState.destinationLocation = {
        ...location,
        isSelected: false,
      }
    }
    return setState(updateState)
  }, [state, location, historyStackContext, setState])

  useEffect(() => {
    updateLog(TITLE, { location: state.location }, historyStackContext)
  }, [historyStackContext, state.location])

  const forwardTo = React.useMemo(() => {
    return state.confirmationChangeType
      ? PAGE_PATH.CONFIRMATION
      : PAGE_PATH.TROUBLE_PLACE_SURROUNDING
  }, [])

  const backTo = React.useMemo((): string => {
    const { date, time } = editingItem.reservation
    const isInputReservation =
      date && time ? PAGE_PATH.RESERVATION : PAGE_PATH.START
    return state.confirmationChangeType
      ? PAGE_PATH.CONFIRMATION
      : isInputReservation
  }, [])

  return (
    <MapTemplate
      title={TITLE}
      usingGeolocation
      location={location}
      setLocation={setLocation}
      setIsDisabled={setIsDisabled}
      markerComponent={<RequesterIcon />}
      addressComponent={<CarIcon color={CLIENT_SETTINGS.colors.iconCar} />}
      forwardLabel={TROUBLE_PLACE_BUTTON_LABEL}
      forwardTo={forwardTo}
      forwardAction={forwardAction}
      isDisabled={isDisabled}
      disabledLabel={TROUBLE_PLACE_BUTTON_LABEL}
      showBack
      backTo={backTo}
      notClearEditingItem
    />
  )
}

export default TroublePlace
